var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "avatar-container", style: { width: _vm.width } },
    [
      _c(
        "div",
        {
          staticClass: "avatar",
          class: [{ "avatar_has-border": _vm.has_border && !_vm.vip }],
        },
        [
          _c("div", {
            staticClass: "avatar__picture",
            style: {
              backgroundImage:
                "url(" +
                (_vm.src
                  ? _vm.$imgfilter(_vm.src)
                  : require("@/assets/images/user/ava_none.jpg")) +
                ")",
            },
          }),
        ]
      ),
      _vm.has_border && _vm.vip && !_vm.is_streamer && !_vm.is_robot
        ? _c("div", {
            staticClass: "avatar__border",
            style: {
              backgroundImage:
                "url(" +
                require("@/assets/images/home_new/vip/" + _vm.vip + ".png") +
                ")",
            },
          })
        : _vm.is_streamer
        ? _c("div", { staticClass: "avatar_streamer_border" })
        : _vm.is_robot
        ? _c("div", { staticClass: "avatar_robot" })
        : _c("div"),
      _vm.curr_metal_url
        ? _c("div", { staticClass: "avatar_badge" }, [
            _c("img", {
              attrs: { src: _vm.$imgfilter(_vm.curr_metal_url), alt: "badge" },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }